import MenuReducer from "./reducer";

export const setMenuList = (payload) => (dispatch) => {
  dispatch(MenuReducer.actions.setMenuList(payload));
};

export const setMenu = (payload) => (dispatch) => {
  dispatch(MenuReducer.actions.setMenu(payload));
};

export const updateList = (payload) => (dispatch) => {
  dispatch(MenuReducer.actions.updateMenu(payload));
};

export const addList = (payload) => (dispatch) => {
  dispatch(MenuReducer.actions.addList(payload));
};
